import { NgModule } from '@angular/core';
import player from 'lottie-web/build/player/lottie_svg';
import { AnimationLoader, LottieComponent, provideCacheableAnimationLoader, provideLottieOptions } from 'ngx-lottie';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';


import { PieceLottieRenderComponent } from './piece-lottie-render.component';


export const pieceLottieRenderModuleEntryComponents = [
  PieceLottieRenderComponent
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule,
    LottieComponent,
  ],
  declarations: pieceLottieRenderModuleEntryComponents,
  providers: [
    provideLottieOptions({ player: () => player }),
    provideCacheableAnimationLoader(),
    AnimationLoader,
  ]
})
export class PieceLottieRenderModule {}

export default pieceLottieRenderModuleEntryComponents;
